import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { VueMaskDirective } from "v-mask";
import { makeServer } from "./server";
// Por que foi comentado?
// import Init from "./services/init";
import VueMoment from 'vue-moment';
import ApiHttpClient from '@/core/api-http-client';
import VueClipboard from 'vue-clipboard2'
import './assets/scss/app.scss';

if (process.env.NODE_ENV === "development") {
  makeServer()
}

Vue.config.productionTip = false;
Vue.directive("mask", VueMaskDirective);
Vue.use(VueMoment);
Vue.use(VueClipboard);

ApiHttpClient.setModifier((options) => {
  const apiOptions = {};

  if (process.env.NODE_ENV === "development") {
    apiOptions.baseURL = '/api/changechip';
  } else {
    apiOptions.baseURL = '/changechip';
  }

  apiOptions.headers = {
    access_key: store.getters.getAccessKey,
    metadata: store.getters.getMetadataCookie
  };

  return {...options, ...apiOptions};
});

// Por que foi comentado?
// Init.start();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
